import React, { useState, useEffect } from "react";

function LandingStats() {
  return (
    <div className="bg-[#FCF9FF]">
      <>
        {/* Card Section */}
        <div className="max-w-[85rem] px-4 py-10 sm:px-6 lg:px-8 lg:py-14 mx-auto">
          {/* Grid */}
          <div className="grid sm:grid-cols-3 ">
            {/* Card */}
           

            <div className="bg-white my-2 rounded-xl md:bg-[#FCF9FF] p-4 md:p-5 relative ">
              <div className="flex md:justify-center justify-start flex-row md:flex-col gap-2 md:gap-6 items-center md:items-center md:items-start">
                
                
                
<svg width="40" height="31" viewBox="0 0 40 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M36.3636 24.1111V12.2278L20 20.6667L0 10.3333L20 0L40 10.3333V24.1111H36.3636ZM20 31L7.27273 24.4556V15.8444L20 22.3889L32.7273 15.8444V24.4556L20 31Z" fill="#4F0696"/>
</svg>


                <div className="mt-3 ps-3">

                <h3 className="font-bold text-3xl lg:text-4xl text-gray-800 darki:text-gray-200 text-start md:text-center">
                    11,000+
                    </h3>
                
                    <p className="text-start md:text-center m-0 text-start justify-start  text-xs uppercase tracking-wide text-gray-500">
                    Students impacted
                    </p>
                  
                </div>
              </div>
            </div>
           
            <div className="bg-white my-2 rounded-xl md:bg-[#FCF9FF] p-4 md:p-5 relative ">
              <div className="flex md:justify-center justify-start flex-row md:flex-col gap-2 md:gap-6 items-center md:items-center md:items-start">
               
               
               
<svg width="35" height="33" viewBox="0 0 35 33" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.0833 24.3332C18.45 24.3332 19.6672 23.9274 20.7349 23.116C21.8026 22.3045 22.5785 21.2582 23.0625 19.9769H11.1042C11.5882 21.2582 12.3641 22.3045 13.4318 23.116C14.4995 23.9274 15.7167 24.3332 17.0833 24.3332ZM12.8125 17.4998C13.5243 17.4998 14.1293 17.2507 14.6276 16.7524C15.1259 16.2542 15.375 15.6491 15.375 14.9373C15.375 14.2255 15.1259 13.6205 14.6276 13.1222C14.1293 12.624 13.5243 12.3748 12.8125 12.3748C12.1007 12.3748 11.4957 12.624 10.9974 13.1222C10.4991 13.6205 10.25 14.2255 10.25 14.9373C10.25 15.6491 10.4991 16.2542 10.9974 16.7524C11.4957 17.2507 12.1007 17.4998 12.8125 17.4998ZM21.3542 17.4998C22.066 17.4998 22.671 17.2507 23.1693 16.7524C23.6675 16.2542 23.9167 15.6491 23.9167 14.9373C23.9167 14.2255 23.6675 13.6205 23.1693 13.1222C22.671 12.624 22.066 12.3748 21.3542 12.3748C20.6424 12.3748 20.0373 12.624 19.5391 13.1222C19.0408 13.6205 18.7917 14.2255 18.7917 14.9373C18.7917 15.6491 19.0408 16.2542 19.5391 16.7524C20.0373 17.2507 20.6424 17.4998 21.3542 17.4998ZM9.60938 7.93317L14.3927 1.74046C14.7344 1.28491 15.1401 0.950358 15.6099 0.736816C16.0797 0.523275 16.5708 0.416504 17.0833 0.416504C17.5958 0.416504 18.087 0.523275 18.5568 0.736816C19.0266 0.950358 19.4323 1.28491 19.774 1.74046L24.5573 7.93317L31.8177 10.3675C32.558 10.5953 33.1417 11.0153 33.5688 11.6274C33.9958 12.2396 34.2094 12.9158 34.2094 13.6561C34.2094 13.9978 34.1596 14.3394 34.0599 14.6811C33.9602 15.0228 33.7965 15.3502 33.5688 15.6634L28.8708 22.3259L29.0417 29.33C29.0701 30.3266 28.7427 31.1665 28.0594 31.8498C27.376 32.5332 26.5788 32.8748 25.6677 32.8748C25.6108 32.8748 25.2976 32.8321 24.7281 32.7467L17.0833 30.6113L9.43854 32.7467C9.29618 32.8037 9.13958 32.8392 8.96875 32.8535C8.79792 32.8677 8.64132 32.8748 8.49896 32.8748C7.58785 32.8748 6.79063 32.5332 6.10729 31.8498C5.42396 31.1665 5.09653 30.3266 5.125 29.33L5.29583 22.2832L0.640625 15.6634C0.412847 15.3502 0.249132 15.0228 0.149479 14.6811C0.0498264 14.3394 0 13.9978 0 13.6561C0 12.9443 0.206424 12.2823 0.619271 11.6701C1.03212 11.058 1.60868 10.6238 2.34896 10.3675L9.60938 7.93317Z" fill="#4F0696"/>
</svg>




                <div className="mt-3 ps-3">

                    <h3 className="font-bold text-3xl lg:text-4xl text-gray-800 darki:text-gray-200 text-start md:text-center">
                      37%
                    </h3>

                
                    <p className="text-start md:text-center m-0 text-start justify-start  text-xs uppercase tracking-wide text-gray-500">
                    Increase in extracurricular activities
                    </p>
                  
                </div>
              </div>
            </div>




           
 




            <div className="bg-white my-2 rounded-xl md:bg-[#FCF9FF] p-4 md:p-5 relative ">
              <div className="flex md:justify-center justify-start flex-row md:flex-col gap-2 md:gap-6 items-center md:items-center md:items-start">
                
<svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.4999 27.9999V11.4624C8.4999 10.6374 8.7999 9.9374 9.3999 9.3624C9.9999 8.7874 10.7124 8.4999 11.5374 8.4999H27.9999C28.8249 8.4999 29.5311 8.79365 30.1186 9.38115C30.7061 9.96865 30.9999 10.6749 30.9999 11.4999V23.4999L23.4999 30.9999H11.4999C10.6749 30.9999 9.96865 30.7061 9.38115 30.1186C8.79365 29.5311 8.4999 28.8249 8.4999 27.9999ZM1.0374 7.3749C0.887398 6.5499 1.0499 5.80615 1.5249 5.14365C1.9999 4.48115 2.6499 4.0749 3.4749 3.9249L19.7499 1.0374C20.5749 0.887398 21.3186 1.0499 21.9811 1.5249C22.6436 1.9999 23.0499 2.6499 23.1999 3.4749L23.5749 5.4999H11.4999C9.8499 5.4999 8.4374 6.0874 7.2624 7.2624C6.0874 8.4374 5.4999 9.8499 5.4999 11.4999V25.8249C5.0999 25.5999 4.75615 25.2999 4.46865 24.9249C4.18115 24.5499 3.9999 24.1249 3.9249 23.6499L1.0374 7.3749ZM27.9999 21.9999H21.9999V27.9999L27.9999 21.9999Z" fill="#4F0696"/>
</svg>

                <div className="mt-3 ps-3">

                <h3 className="font-bold text-3xl lg:text-4xl text-gray-800 darki:text-gray-200 text-start md:text-center">
                    2,600+
                    </h3>
                
                    <p className="text-start md:text-center m-0 text-start justify-start  text-xs uppercase tracking-wide text-gray-500">
                    Reports generated
                    </p>
                  
                </div>
              </div>
            </div>


            
          </div>
          {/* End Grid */}
        </div>
        {/* End Card Section */}
      </>
    </div>
  );
}

export default LandingStats;
